/**
 * Filtros de colección sin recargar la página.
 *
 * Antes cada checkbox hacía `this.form.submit()`: el navegador recargaba la
 * colección entera y aterrizabas arriba del todo, con el encabezado y la
 * descripción, lejos de la lista que querías ver.
 *
 * Ahora se pide la misma URL, se toma de la respuesta sólo la lista y los
 * filtros, y se reemplazan en su sitio. La página no se mueve: sigues donde
 * estabas y sólo cambia lo que tenía que cambiar.
 *
 * La URL sí se actualiza (history.pushState), así que el enlace se puede
 * copiar y compartir, y el botón atrás del navegador deshace el filtro.
 */
(function () {
  var form = document.getElementById("CollectionFiltersForm");
  if (!form || !window.fetch || !window.DOMParser) return;

  var MAIN = ".ma-c-main";
  var FORM = ".ma-c-side__form";
  var enCurso = null;

  /** Qué grupos de filtros están desplegados, para no cerrarlos al refrescar. */
  function grupos() {
    var abiertos = [];
    document.querySelectorAll("details[data-ma-cfilter]").forEach(function (d, i) {
      if (d.open) abiertos.push(i);
    });
    return abiertos;
  }

  function restaurarGrupos(abiertos) {
    document.querySelectorAll("details[data-ma-cfilter]").forEach(function (d, i) {
      d.open = abiertos.indexOf(i) !== -1;
    });
  }

  function urlDelFormulario() {
    // Se busca cada vez: el formulario se reemplaza en cada filtrado, así que
    // la referencia inicial queda fuera del DOM y devolvería el estado viejo.
    var actual = document.getElementById("CollectionFiltersForm");
    if (!actual) return window.location.pathname;

    // Se parte de lo que ya hay en la URL y sólo se reescribe lo que este
    // formulario controla. "Piel" no son casillas sino enlaces, así que su
    // filtro no viaja en el formulario: si se construyera la URL desde cero,
    // marcar un beneficio borraría el tipo de piel elegido.
    var params = new URLSearchParams(window.location.search);
    var propios = {};
    for (var i = 0; i < actual.elements.length; i++) {
      var n = actual.elements[i].name;
      if (n) propios[n] = true;
    }
    Object.keys(propios).forEach(function (n) {
      params.delete(n);
    });

    new FormData(actual).forEach(function (valor, clave) {
      // Los rangos de precio vacíos no deben ensuciar la URL.
      if (String(valor).trim() !== "") params.append(clave, valor);
    });

    var qs = params.toString();
    return window.location.pathname + (qs ? "?" + qs : "");
  }

  function aplicar(url, guardarHistorial) {
    var main = document.querySelector(MAIN);
    if (!main) return;

    // Señal de que algo está pasando, sin mover nada de sitio.
    main.setAttribute("aria-busy", "true");
    main.style.opacity = "0.5";
    main.style.transition = "opacity .15s ease";

    if (enCurso) enCurso.abort && enCurso.abort();
    var ctrl = window.AbortController ? new AbortController() : null;
    enCurso = ctrl;

    fetch(url, { credentials: "same-origin", signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var nuevoMain = doc.querySelector(MAIN);
        var nuevoForm = doc.querySelector(FORM);
        if (!nuevoMain) throw new Error("respuesta sin lista");

        var abiertos = grupos();

        var actual = document.querySelector(MAIN);
        actual.parentNode.replaceChild(nuevoMain, actual);

        if (nuevoForm) {
          var formActual = document.querySelector(FORM);
          if (formActual) formActual.parentNode.replaceChild(nuevoForm, formActual);
          restaurarGrupos(abiertos);
        }

        if (guardarHistorial) window.history.pushState({ maFiltros: true }, "", url);
      })
      .catch(function (e) {
        if (e && e.name === "AbortError") return;
        // Si algo falla, se navega como siempre: mejor recargar que quedarse quieto.
        window.location.href = url;
      })
      .finally(function () {
        var m = document.querySelector(MAIN);
        if (m) {
          m.removeAttribute("aria-busy");
          m.style.opacity = "";
        }
      });
  }

  // Delegado en el documento: el formulario se reemplaza en cada filtrado.
  document.addEventListener("change", function (e) {
    var t = e.target;
    if (!t.closest) return;
    var f = t.closest("#CollectionFiltersForm");
    if (!f) return;
    e.preventDefault();
    aplicar(urlDelFormulario(), true);
  });

  // "Piel" se pinta como botones enlazados, no como casillas. Sin esto cada
  // clic navegaba —recargando y saltando arriba— y además perdía los demás
  // filtros, porque cada enlace lleva sólo el suyo.
  document.addEventListener("click", function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest(".ma-c-side__btn");
    if (!btn || !btn.getAttribute("href")) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;

    e.preventDefault();

    var destino = new URL(btn.getAttribute("href"), window.location.origin);
    var params = new URLSearchParams(destino.search);

    // Se conserva lo que el formulario tenga marcado ahora mismo.
    var form = document.getElementById("CollectionFiltersForm");
    if (form) {
      new FormData(form).forEach(function (valor, clave) {
        if (String(valor).trim() === "") return;
        if (params.getAll(clave).indexOf(valor) === -1) params.append(clave, valor);
      });
    }

    var qs = params.toString();
    aplicar(destino.pathname + (qs ? "?" + qs : ""), true);
  });

  document.addEventListener("submit", function (e) {
    if (e.target && e.target.id === "CollectionFiltersForm") {
      e.preventDefault();
      aplicar(urlDelFormulario(), true);
    }
  });

  // El estado con el que se entra a la colección también es nuestro: sin
  // marcarlo, al volver atrás desde un filtro el popstate llegaba con
  // state=null y la lista se quedaba filtrada aunque la URL ya no lo estuviera.
  if (!window.history.state || !window.history.state.maFiltros) {
    window.history.replaceState({ maFiltros: true }, "", window.location.href);
  }

  // El botón atrás deshace el filtro sin recargar.
  window.addEventListener("popstate", function (e) {
    if (e.state && e.state.maFiltros) aplicar(window.location.href, false);
  });
})();
